<template>
  <div :style="{'height': height, 'overflow': overflow}" v-if="isActive">
    <ks-skeleton-list v-if="loading"/>
    <table
        v-show="!loading"
        :class="{'table': true, 'table-hover': tableHover, [classes]: true}"
    >
      <thead
          @drop="dropHeader($event)"
          @dragover="allowDrop($event)"
      >
      <tr v-if="autoHeaders">
        <ks-list-table-header
            v-for="header in headers"
            :key="header.title"
            :data-source="header.dataSource"
            :icon-class="header.icon"
            :title="header.title"
            :sortable="header.sortable"
            :hiddenable="header.hiddenable"
            :clickable="header.clickable"
            :label="header.label"
            :showIfHasPermission="header.showIfHasPermission"
        >
        </ks-list-table-header>
      </tr>
      </thead>
      <tbody v-show="list.length > 0">
      <tr v-for="(row, idxRow) in l_list"
          style="position: relative;"
          :id="'tr_' + row.id + '_' + idxRow" :key="'row' + idxRow"
          :class="{
          'table-active': idxRow === selectedListItemIndex, 
          'subrow': row[subfield], 
          'dragged-on-top':row.__draggedOn && draggable,
          'small-row': smallRow
        }"
          :draggable="draggable"
          @click="rowSelected(idxRow)"
          @mouseover="setHoverState(row, true)"
          @mouseleave="setHoverState(row, false)"
          @dragenter="dragEnter($event, row)"
          @dragstart="dragStart(row)"
          @dragend="$emit('dragEnd', row)"
          @dragleave="dragLeave($event, row)"
          @dragover="allowDrop($event)"
          @drop="drop($event, row, true)"
          v-show="displayRow(row)"
      >
        <slot
            :row="row"
            :activeViewType="activeViewType"
            :index="idxRow"
        >
        </slot>
      </tr>
      </tbody>
      <div v-if="list.length == 0"
           v-html="noRecordHtml"
      />
    </table>
  </div>
</template>

<script>
import checkPermissions from '../../../mixins/checkPermissions';

export default {
  name: "ks-data-list-table",
  mixins: [checkPermissions],
  props: {
    height: {type: String, default: 'calc(100vh - 190px)'},
    overflow: {type: String, default: 'auto'},
    separateDrag: {type: Boolean, default: false},
    draggable: {type: Boolean, default: false},
    subfield: {type: String, default: ''},
    tableHover: {type: Boolean, default: true},
    smallRow: {type: Boolean, default: false},
    autoHeaders: {type: Boolean, default: true},
    columnHiddenEnable: {type: Boolean, default: true},
    classes: {type: String, default: null},
    noRecordHtml: {type: String, default: 'No records found'},
    parentRecordIdName: {type: String, default: null},
    recordIdName: {type: String, default: null},
    moveAboveRecordIdName: {type: String, default: null},
    compareField1: {type: String, default: 'campaign_id'},
    compareField2: {type: String, default: null},
    parent: {type: String, default: null},
    parentId: {type: String, default: null},
    showRowConditionField: {type: String, default: null},
    showRow: {type: Boolean, default: true},
  },
  computed: {
    loading() {
      return this.data_provider_ref ? this.data_provider_ref.l_loading : true;
    },
    list() {
      return this.$parent.list;
    },
    l_list() {
      if (this.$parent.list.length > 0) {
        return this.$parent.list;
      } else {
        let outputs = app.sdk[this.data_provider_ref.dbName][`${this.data_provider_ref.dbTableName}_list_outputs`];
        let index = outputs.findIndex(o => o.name === this.data_provider_ref.defaultListResultSetName);
        if (index !== -1) {
          let schema = {};
          for (let input of outputs[index].fields) {
            schema[input.name] = null;
          }
          return [schema];
        } else {
          return [];
        }
      }
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    },
    selectedListItemIndex() {
      return this.$parent.data_provider_ref.l_selectedListItemIndex;
    },
    activeViewType() {
      return this.$parent.activeViewType;
    },
    columns() {
      return this.$parent.columns;
    },
    isActive() {
      return this.$parent.activeViewType == 'table';
    }
  },
  watch: {
    isActive: function (val) {
      if (val) this.$parent.activeViewComponent = this;
    }
  },
  methods: {
    displayRow(row) {
      if (this.showRowConditionField) {
        return !row[this.showRowConditionField] || this.showRow;
      } else {
        return true;
      }
    },
    columnHeaderEvent(evt, ref) {
      if (evt === 'sort') {
        for (let key in this.columns) {
          this.columns[key].sortType = null;
        }
        this.$set(this.columns[ref.dataSource], 'sortType', ref.sortType);
        this.data_provider_ref.setOrderBy(`${ref.dataSource} ${ref.sortType}`, true);
      }
      if (evt === 'hidden') {
        this.$set(this.columns[ref.dataSource], 'isHidden', ref.isHidden);
      }
      if (evt === 'selected') {
        this.$emit('onHeaderClick', ref);
      }
    },
    rowSelected(idxRow = null) {
      this.data_provider_ref.setSelectedListItemIndex(idxRow, this.data_provider_ref.enableReadRecordOnListIndexChange);
      if (this.parent && this.parentId) {
        if (this.list[idxRow][this.parentId]) this.setActiveParents([this.list[idxRow][this.parentId]]);
      }
      this.$emit('onRowClick', this.list[idxRow]);
    },
    setActiveParents(parentIds = []) {
      for (let parentId of parentIds) {
        let pIndex = this.activeParents.findIndex(pId => pId == parentId);
        if (pIndex > -1) {
          this.activeParents.splice(pIndex, 1);
        } else {
          this.activeParents.push(parentId);
        }
      }
    },
    isParentActive(parentId) {
      return this.activeParents.includes(parentId);
    },
    setHoverState(row, value) {
      this.$set(row, '__hovered', value);
    },
    dragStart(row) {
      if (!this.draggable) return;
      this.draggedRow = row;
      this.$emit('dragStart', row)
    },
    topHalf(id) {
      let top = $('#' + id).offset().top;
      let bottom = $('#' + id).offset().top + $('#' + id).height();
      let half = (bottom - top) / 2;
      let value = this.mouseY < (top + half);
      return value;
    },
    dragEnter(e, row) {
      if (!this.draggable) return;
      let _this = this;
      this.counters[row.id] ? this.counters[row.id]++ : this.counters[row.id] = 1;
      _this.$emit('dragEnter', row, e);
      let foundIdx = this.data_provider_ref.list.findIndex(item => item.id === row.id);
      this.$set(this.data_provider_ref.list[foundIdx], '__draggedOn', true);
      e.preventDefault();
    },
    async dragLeave(e, row) {
      if (!this.draggable) return;
      let _this = this;
      _this.counters[row.id]--;
      if (_this.counters[row.id] === 0) {
        this.$emit('dragLeave', row, e)
        row.__draggedOn = false
      }
      e.preventDefault();
    },
    setMousePostion(e) {
      this.mouseY = e.pageY;
    },
    dropHeader(ev) {
      ev.preventDefault();
      this.$emit('droppedHeader');
    },
    allowDrop(ev) {
      if (!this.draggable) return;
      this.mouseY = ev.pageY;
      ev.preventDefault();
    },
    drop(ev, row, top) {
      if (!this.draggable) return;
      ev.preventDefault();
      if (top) {
        this.$emit('droppedTop', row);
        this.droppedTop(row)
      } else {
        this.$emit('dropped', row);
        this.dropped(row);
      }
    },
    async droppedTop(value) {
      this.dropRow = value;
      if (this.compareField1) {
        if (this.draggedRow[this.compareField1] !== this.dropRow[this.compareField1]) {
          alert(`Ordering an item above another item that has a different ${this.compareField1} is not allowed.`);
          return;
        }
      }
      if (this.compareField2) {
        if (this.draggedRow[this.compareField2] !== this.dropRow[this.compareField2]) {
          alert(`Ordering an item above another item that has to a different ${this.compareField2} is not allowed.`);
          return;
        }
      }
      let updateRecord = {};
      updateRecord[this.moveAboveRecordIdName] = this.dropRow.id;
      await this.data_provider_ref.updatePartialRecord(
          this.draggedRow.campaign_id,
          this.draggedRow.id,
          updateRecord
      );
      if (this.consoleLogs) console.log("list table loadList");
      this.data_provider_ref.loadList();
    },
    async dropped(value) {
      this.dropRow = value;
      if (this.compareField1) {
        if (this.draggedRow[this.compareField1] !== this.dropRow[this.compareField1]) {
          alert(`Adding a subitem as a that has a different ${this.compareField1} is not allowed.`);
          return;
        }
      }
      if (this.draggedRow.id === this.dropRow.id) {
        return;
      }
      let updateRecord = {};
      updateRecord[this.parentRecordIdName] = this.dropRow.id;
      if (this.dropRow[this.parentRecordIdName]) {
        updateRecord[this.parentRecordIdName] = this.dropRow[this.parentRecordIdName];
      }
      updateRecord[this.recordIdName] = this.draggedRow.id;
      await this.data_provider_ref.updatePartialRecord(
          this.draggedRow.campaign_id,
          this.draggedRow.id,
          updateRecord
      );
      if (this.consoleLogs) console.log("dropped loadList");
      this.data_provider_ref.loadList();
    },
    getComponentConfiguration() {
      let config = {'columns': {}};
      //define columns configuration;
      for (let key in this.columns) {
        config['columns'][key] = {
          'sortType': this.columns[key].sortType,
          'isSortable': this.columns[key].isSortable,
          'isHidden': this.columns[key].isHidden
        }
      }
      return config;
    },
    setComponentConfiguration(config) {
      if (config.columns) {
        for (let key in this.columns) {
          this.$set(this.columns, key, {...this.columns[key], ...config.columns[key]});
        }
      }
    }
  },
  mounted() {
    if (this.isActive) {
      this.$parent.activeViewComponent = this;
    }
  },
  data() {
    return {
      headers: [],
      draggedRow: null,
      dropRow: null,
      mouseY: null,
      counters: {},
      activeParents: []
    }
  }
}
</script>
<style>

table {
  text-align: left;
  position: relative;
  border-collapse: collapse;
}

th {
  padding: 0.25rem;
  background: white;
  position: sticky;
  top: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.subrow {
  background: #f7f7f7 !important;
}

.dragged-on {
  background: #D8EBFF !important;
}

.dragged-on-top {
  background-image: linear-gradient(#007bff, white, white, white);
}

.small-row {
  height: 27px !important;
  max-height: 27px !important;
  min-height: 27px !important;
}
tr {
  background-color: white;
}
</style>
